export default "__VITE_ASSET__D2EJ2KsL__"